export const eventTimeFormat = {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: true
};

export const headerToolbar = {
  start: 'prev,next,today',
  center: 'title',
  end: 'timeGridWeek,dayGridMonth'
};

export const slotLabelFormat = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: true
};

// Etiqueta de hora COMPACTA para FullCalendar ("6am", "1pm", "12pm") — aprovecha el ancho,
// sobre todo en mobile. Se usa vía `slotLabelContent`.
export const compactSlotLabelContent = (arg) => {
  const h = arg.date.getHours();
  return `${(h % 12) || 12}${h < 12 ? 'am' : 'pm'}`;
};

export const titleFormat = {
  month: 'short',
  day: '2-digit',
  year: 'numeric'
};
